import { Viewer } from './viewer';

/**
 * Send event to Google Tag Manager (GTM)
 *
 * @param args - GTM arguments (event name and properties)
 *
 * Usage:
 *   gtm('event', 'event_name', { param1: 'value1', param2: 'value2' })
 *
 * Debug mode:
 *   Events are logged to console with [GTM] prefix for easy debugging
 */
export function gtm(...args: (string | object)[]): void {
  window.dataLayer = window.dataLayer || [];
  // GTM requires object pushes (not arrays) for custom event triggers to match.
  // Extract the params object; fall back to { event: eventName } for string-only calls.
  const params = args.find((arg) => typeof arg === 'object');
  window.dataLayer.push(params ?? { event: args[1] as string });

  // Debug logging in development
  if (import.meta.env.MODE === 'development' && console.log) {
    const [command, eventName, params] = args;
    if (command === 'event' && typeof eventName === 'string') {
      console.log(`[GTM] ${eventName}`, params);
    } else {
      console.log('[GTM]', ...args);
    }
  }
}

export function initSegmentIdentifier(viewer: Viewer): void {
  const { analytics } = window;
  if (!analytics || !analytics.identify) return;

  const analyticsTraits = {
    name: viewer.full_name,
    email: viewer.email?.address,
    userId: viewer.id,
  };

  // Helpful for GTM triggers/variables
  window._analyticsTraits = analyticsTraits;

  if (viewer.id) {
    analytics.identify(viewer.id, analyticsTraits);
  }
}

export function segmentTracking(eventName: string, properties?: Record<string, unknown>): void {
  const { analytics } = window;

  if (!analytics || !analytics.identify) {
    return;
  }

  analytics.track(eventName, properties);
}
